var React = require('react');

function Show (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15 1.5L8 8.5L1 1.5","stroke":"#1A1A1A","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Show.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = Show;

Show.default = Show;
